import { useSite } from "../../contexts/Site";
import { findPage } from "../../model/pages";
import { SitePage } from "../../model/site";
import { useQueryUrl } from "../QueryUrl";

/**
 * The page being edited, from `?page=<id>`; the home (null) without it. `pageGone`: `?page` names a page that no
 * longer exists (deleted in the meantime), so the screen must not edit the home in its place.
 */
export const useCurrentPage = (): { pageId: string | null; page: SitePage | undefined; pageGone: boolean } => {
  const { site } = useSite();
  const requested = useQueryUrl().get("page");
  const page = findPage(site, requested);

  return { pageId: page?.id ?? null, page, pageGone: !!requested && !page };
};

/**
 * Where the Keepo's pages are listed: the editor's way in and out, creating it or editing it once published (the
 * home is one of them; each one's sections come back here, and going on leads to the style).
 */
export const PAGES_PATH = "/editor/pages";

/** `path` keeping the page being edited, so the next screen edits the same page. */
export const withPage = (path: string, pageId: string | null): string =>
  pageId ? `${path}${path.includes("?") ? "&" : "?"}page=${encodeURIComponent(pageId)}` : path;
